<div class="filter-panel-container">
  <button
    class="x_btn x_sm x_secondary filter-panel-toggle"
    (click)="toggleFilterPanel()"
    [attr.e2e-attr]="e2eAttrs.FILTER_PANEL_TOGGLE_BUTTON"
  >
    <span class="counts">{{ filterCounter }}</span>
    <span class="filters-title">{{
      I18n.CommonStrings.Filters | translate
    }}</span>
    <i
      [ngClass]="{
        'icon-angle-up': isFilterPanelShown,
        'icon-angle-down': !isFilterPanelShown,
      }"
    ></i>
  </button>

  @if (isFilterPanelShown) {
    <div class="filter-panel-content">
      <div class="overlay" (click)="onOverlayClick($event)"></div>
      <form
        [formGroup]="filterForm"
        class="grid-row group-vertical filter-slider"
        [class.fullscreen]="isFullScreen"
      >
        @if (showResetButton) {
          <div
            [attr.e2e-attr]="e2eAttrs.FILTER_PANEL_RESET_BUTTON"
            class="grid-row grid-header"
          >
            <button
              type="button"
              class="x_btn x_sm x_bordered"
              (click)="clearFilters()"
            >
              {{ I18n.CommonFilters.ResetAllFilters | translate }}
            </button>
          </div>
        }
        @if (isShowResetAllButton()) {
          <div
            [attr.e2e-attr]="e2eAttrs.FILTER_PANEL_RESET_ALL_BUTTON"
            class="grid-row grid-header"
          >
            <button
              type="button"
              class="x_btn x_sm x_bordered"
              [disabled]="!isShowResetAllButton()"
              (click)="resetAll()"
            >
              {{ I18n.CommonFilters.ResetAllAndApply | translate }}
            </button>
          </div>
        }
        <content-scroll>
          <div class="grid-content group-vertical">
            <ul class="filter-list">
              @for (filter of filtersList; track filter.id) {
                <li
                  [formGroup]="filterForm.controls[filter.id]"
                  [attr.e2e-attr]="e2eAttrs.FILTER_PANEL_OPTIONS"
                >
                  @switch (filter.type) {
                    @default {
                      <filter-settings
                        [filter]="filter"
                        [formCategory]="filterForm.controls[filter.id]"
                      ></filter-settings>
                    }
                  }
                </li>
              }
            </ul>
          </div>
        </content-scroll>
        <div class="grid-row grid-footer">
          @if (showCancelButton) {
            <button
              type="button"
              class="x_btn x_flat"
              [attr.e2e-attr]="e2eAttrs.FILTER_PANEL_CANCEL_BUTTON"
              (click)="onCancel()"
            >
              {{ I18n.CommonActions.Cancel | translate }}
            </button>
          }
          <button
            type="button"
            class="x_btn x_primary x_flat"
            [attr.e2e-attr]="e2eAttrs.FILTER_PANEL_APPLY_BUTTON"
            (click)="onSubmit()"
          >
            {{ I18n.CommonActions.Apply | translate }}
          </button>
        </div>
      </form>
    </div>
  }
</div>
